// Klaviyo BIS - Simple Init and Reinit
(function() {
  // Store config once to avoid duplication
  const bisConfig = {
    trigger: {
      collection_page_class: window.klaviyo_bis.collection_page_class,
      collection_page_text: window.klaviyo_bis.collection_page_text,
      collection_page_width: '100%',
      collection_page_padding: '12px 10px',
      collection_page_text_align: 'center',
      
      product_page_class: window.klaviyo_bis.product_page_class,
      product_page_text: window.klaviyo_bis.product_page_text,
      product_page_text_align: window.klaviyo_bis.product_page_text_align,
      product_page_margin: window.klaviyo_bis.product_page_margin,
      product_page_width: window.klaviyo_bis.product_page_width,
      
      alternate_anchor: window.klaviyo_bis.alternate_anchor,
      replace_anchor: window.klaviyo_bis.replace_anchor
    },
    modal: {
      headline: window.klaviyo_bis.headline,
      body_content: window.klaviyo_bis.body_content,
      email_field_label: window.klaviyo_bis.email_field_label,
      email: window.klaviyo_bis.email,
      button_label: window.klaviyo_bis.button_label,
      subscription_success_label: window.klaviyo_bis.subscription_success_label,
      footer_content: window.klaviyo_bis.footer_content,
      close_label: window.klaviyo_bis.close_label,
      
      newsletter_subscribe_label: window.klaviyo_bis.newsletter_subscribe_label,
      subscribe_checked: window.klaviyo_bis.subscribe_checked,
      
      is_powered_by_link: false,
      
      drop_background_color: window.klaviyo_bis.drop_background_color,
      background_color: window.klaviyo_bis.background_color,
      text_color: window.klaviyo_bis.text_color,
      button_text_color: window.klaviyo_bis.button_text_color,
      button_background_color: window.klaviyo_bis.button_background_color,
      close_button_color: window.klaviyo_bis.close_button_color,
      error_background_color: window.klaviyo_bis.error_background_color,
      error_text_color: window.klaviyo_bis.error_text_color,
      success_background_color: window.klaviyo_bis.success_background_color,
      success_text_color: window.klaviyo_bis.success_text_color,
      
      additional_styles: window.klaviyo_bis.additional_styles
    }
  };
  
  // Simple init function
  function init(initialLoad = false) {
    if (window.klaviyo && typeof window.klaviyo.init === 'function') {
      klaviyo.init({
        account: window.klaviyo_bis.account,
        list: window.klaviyo_bis.list,
        platform: 'shopify',
        include_on_tags: window.klaviyo_bis.include_on_tags,
        exclude_on_tags: window.klaviyo_bis.exclude_on_tags,
        collection_urls: ["/collections/", "/search", "/pages/", "/"]
        // "/collections/", "/search", 
      });
      
      // Enable BIS
      klaviyo.enable('backinstock', bisConfig);

      setTimeout(() => {
        const bisTriggers = document.querySelectorAll('.klaviyo-product-container, .klaviyo-button-container');
        bisTriggers.forEach(trigger => {
          trigger.style.position = 'relative';
          // trigger.classList.remove('hidden');
        });

        if (initialLoad) {
          document.body.classList.add('initial-klaviyo-load');
        }
      }, 0);

      return true;
    }
    return false;
  }

  
  // Reset function - cleanly reloads Klaviyo
  window.resetKlaviyoBIS = function() {
    // Find original script
    const onsiteScript = document.querySelector('script[src*="klaviyo.com/media/js/onsite/onsite.js"]');
    if (!onsiteScript) return false;
    onsiteScript.remove();

    const bisTriggersAndIframes = document.querySelectorAll(
      '.klaviyo-bis-trigger, #klaviyo-bis-iframe'
    );
    bisTriggersAndIframes.forEach(trigger => trigger.remove());
    
    // Delete Klaviyo objects
    if (window.klaviyo) delete window.klaviyo;
    if (window.klaviyoBIS) delete window.klaviyoBIS;
    
    // Create new script element
    const newScript = document.createElement('script');
    newScript.src = onsiteScript.src;
    newScript.defer = true;
    
    // Add to page
    document.body.appendChild(newScript);
    
    // Check for Klaviyo to be ready
    let attempts = 0;
    const checkInterval = setInterval(function() {
      if (init()) {
        // Refresh Klaviyo listeners after initialization
        setTimeout(() => {
          window.refreshKlaviyoListeners();
        }, 1000);
        
        clearInterval(checkInterval);
      } else if (attempts >= 10) {
        clearInterval(checkInterval);
      }
      attempts++;
    }, 300);
    
    return true;
  };
  
  // Initial load - wait for Klaviyo
  let attempts = 0;
  const checkInterval = setInterval(function() {
    attempts++;
    
    if (init(true)) {
      clearInterval(checkInterval);
    } else if (attempts >= 10) {
      clearInterval(checkInterval);
    }
  }, 300);
})();


// Store a reference to the original addEventListener method
const originalKlaviyoAddEventListener = Element.prototype.addEventListener;

// Keep track of Klaviyo listeners
let klaviyoListeners = [];

Element.prototype.addEventListener = function(type, listener, options) {
  // Check if this is a Klaviyo BIS click handler being added to the body
  if (type === 'click' && this.tagName === 'BODY') {
    const listenerString = String(listener);
    const isKlaviyo = listenerString.includes('klaviyo') || 
                     listenerString.includes('onsite') ||
                     listenerString.includes('function(d){d=w(d)') ||
                     // Check if function was created from onsite.js
                     listener.toString().includes('onsite.js');
    
    if (isKlaviyo) {
      // Store information about this listener
      klaviyoListeners.push({
        element: this,
        listener: listener,
        options: options
      });
      
      // Only add the listener if it's the first one
      if (klaviyoListeners.length === 1) {
        return originalKlaviyoAddEventListener.call(this, type, listener, options);
      }
      
      console.log('Prevented duplicate click handler, stored for later use');
      return;
    }
  } else {
    // For all other event listeners, proceed normally
    return originalKlaviyoAddEventListener.call(this, type, listener, options);
  }
};

// Function to refresh Klaviyo listeners
window.refreshKlaviyoListeners = function() {
  if (klaviyoListeners.length <= 1) return; // Nothing to do
  
  // Get all listeners except the latest one
  const oldListeners = klaviyoListeners.slice(0, -1);
  
  // Get the latest listener
  const latestListener = klaviyoListeners[klaviyoListeners.length - 1];
  
  // Remove old listeners if possible
  oldListeners.forEach(item => {
    try {
      item.element.removeEventListener('click', item.listener, item.options);
      console.log('Removed old Klaviyo listener');
    } catch (e) {
      console.log('Could not remove old listener:', e);
    }
  });
  
  // Make sure the latest listener is added
  try {
    latestListener.element.removeEventListener('click', latestListener.listener, latestListener.options);
    originalKlaviyoAddEventListener.call(
      latestListener.element, 
      'click', 
      latestListener.listener, 
      latestListener.options
    );
    console.log('Applied latest Klaviyo listener');
  } catch (e) {
    console.log('Error applying latest listener:', e);
  }
  
  // Reset the listeners array to only contain the latest
  klaviyoListeners = [latestListener];
};